import { render, staticRenderFns } from "./serverDirectAllocationTable.vue?vue&type=template&id=734b612e&scoped=true"
import script from "./serverDirectAllocationTable.vue?vue&type=script&lang=js"
export * from "./serverDirectAllocationTable.vue?vue&type=script&lang=js"
import style0 from "./serverDirectAllocationTable.vue?vue&type=style&index=0&id=734b612e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734b612e",
  null
  
)

export default component.exports